import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getStartInfo } from "./start-info";
import { CohortIdsSearchParameterKey, ExperimentSearchParameterKeys, noRevisionId, } from "./url.types";
export function createSafeOriginUrl(url) {
    const { getDefaultOrigin, getSafeOrigins } = getStartInfo();
    const defaultOrigin = getDefaultOrigin();
    const safeOrigins = getSafeOrigins();
    let safeOriginUrl;
    try {
        safeOriginUrl = new URL(url, defaultOrigin);
    }
    catch (ex) {
        return null;
    }
    if (!safeOrigins.includes(safeOriginUrl.origin)) {
        return null;
    }
    return safeOriginUrl.href;
}
export async function addExperimentsSearchParams(url) {
    var _a;
    let extendedUrl;
    try {
        extendedUrl = new URL(url);
    }
    catch (ex) {
        return null;
    }
    extendedUrl.searchParams.append(ExperimentSearchParameterKeys.revision, (_a = (await ewe.remoteConfig.getRevisionId())) !== null && _a !== void 0 ? _a : noRevisionId);
    extendedUrl.searchParams.append(ExperimentSearchParameterKeys.variants, await ewe.experiments.getEncodedExperiments());
    return extendedUrl.href;
}
export async function addCohortAssignmentsSearchParam(url) {
    let extendedUrl;
    try {
        extendedUrl = new URL(url);
    }
    catch (ex) {
        return null;
    }
    extendedUrl.searchParams.append(CohortIdsSearchParameterKey, await ewe.cohorts.getEncodedCohorts());
    return extendedUrl.href;
}
function parseDomains(source, separator) {
    let domains;
    if (source[0] !== "~" && !source.includes(separator)) {
        domains = new Map([
            ["", false],
            [source, true],
        ]);
    }
    else {
        domains = null;
        let hasIncludes = false;
        for (let domain of source.split(separator)) {
            if (domain === "") {
                continue;
            }
            let include;
            if (domain[0] === "~") {
                include = false;
                domain = domain.substring(1);
            }
            else {
                include = true;
                hasIncludes = true;
            }
            if (!domains) {
                domains = new Map();
            }
            domains.set(domain, include);
        }
        if (domains) {
            domains.set("", !hasIncludes);
        }
    }
    return domains;
}
function isValidIPv4Address(address) {
    return /^(((2[0-4]|1[0-9]|[1-9])?[0-9]|25[0-5])\.){4}$/.test(address + ".");
}
function isValidHostname(hostname) {
    if (isValidIPv4Address(hostname)) {
        return true;
    }
    if (hostname[0] === "[" && hostname[hostname.length - 1] === "]") {
        return true;
    }
    if (hostname[hostname.length - 1] === ".") {
        hostname = hostname.substring(0, hostname.length - 1);
    }
    if (hostname.length > 253) {
        return false;
    }
    const labels = hostname.split(".");
    for (const label of labels) {
        if (!/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(label)) {
            return false;
        }
    }
    if (!/\D/.test(labels[labels.length - 1])) {
        return false;
    }
    return true;
}
export function isDomainList(list) {
    const domains = parseDomains(list, ",");
    if (domains === null) {
        return true;
    }
    return Array.from(domains.keys()).every((domain) => !domain || isValidHostname(domain));
}
